import React from "react";
import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  useDisclosure,
} from "@heroui/modal";

import { Button } from "@heroui/button";

const SnowFlakeModal = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [scrollBehavior, setScrollBehavior] = React.useState("inside");

  return (
    <>
      <Button size="sm" onPress={onOpen}>
        Learn About FRC’s Radar Analysis
      </Button>
      <Modal isOpen={isOpen} onClose={onClose} scrollBehavior={scrollBehavior}>
        <ModalContent>
          <ModalHeader className="flex flex-col gap-1">
            FRC’s Radar Analysis Explained
          </ModalHeader>
          <ModalBody>
            <p>
              This analysis evaluates a company across five key areas, aiming to
              provide investors with a nuanced understanding of the
              company&apos;s overall health, performance, and attractiveness in
              terms of valuation.
            </p>
            <h3>
              <strong>Past Performance (Stock Price)</strong>
            </h3>
            <p>
              Assesses year-over-year share performance: &apos;5&apos; denotes
              YoY increase of over 40%, while &apos;E&apos; denotes a YoY
              decrease
            </p>
            <h3>
              <strong> Revenue Growth </strong>
            </h3>
            <p>
              Assesses the three-year revenue growth per share: &apos;5&apos;
              denotes growth rates above 40% whil &apos;1&apos; denotes negative
              growth
            </p>
            <h3>
              <strong> Profitability </strong>
            </h3>
            <p>
              Analyzes return on equity as a measure of profitability:
              &apos;A&apos; denotes returns over 20%, while &apos;1&apos;
              denotes returns below 5%.
            </p>
            <h3>
              <strong> Value </strong>
            </h3>
            <p>
              Analyzes the price-earnings ratio: &apos;5&apos; denotes a ratio
              below 5, hinting at potential underpricing, while &apos;1&apos;
              represents a ratio above 20, signaling potential overpricing.
            </p>
            <h3>
              <strong> Health </strong>
            </h3>
            <p>
              Analyzes the total debt to capitalization ratio: &apos;5&apos;
              denotes a ratio below 0.1, indicating robust financial health,
              while &apos;1&apos; represents a ratio above 1.0, suggesting
              elevated debt levels.
            </p>
            <p>
              Each metric is carefully calculated based on historical data and
              current financial ratios to provide investors with a nuanced
              understanding of a company&apos;s overall health and potential for
              future performance.
            </p>
          </ModalBody>
          <ModalFooter>
            <Button color="danger" variant="light" onPress={onClose}>
              Close
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export default SnowFlakeModal;
